import React, { useState } from "react";
import { Button, Col, Container, Form, Row, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useLoginMutation } from "../services/appApi";
import "./Signup.css";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [login, { isError, isLoading, error }] = useLoginMutation();
    function handleLogin(e) {
        e.preventDefault();
        login({ email, password });
    }
    return (
        <Container>
            <Row>
            <Col md={6} className="signup__image--container"></Col>
                <Col md={6} className="signup__form--container">
                    <Form style={{ width: "100%" }} onSubmit={handleLogin} >
                        <h1>Create an account</h1>
                        {isError && <Alert variant="danger">{error.data}</Alert>}
                        <Form.Group className="form-group">
                            <Form.Label className="form-label">Email Address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" className="form-input" value={email} required onChange={(e) => setEmail(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-3 form-group">
                            <Form.Label className="form-label">Password</Form.Label>
                            <Form.Control type="password" placeholder="Enter Password" className="form-input" value={password} required onChange={(e) => setPassword(e.target.value)} />
                        </Form.Group>

                        <Form.Group>
                            <Button type="submit" disabled={isLoading}>
                                Login
                            </Button>
                        </Form.Group>
                        <p className="pt-3 text-center">
                        Don't have an account? <Link to="/signup">Signup</Link>{" "}
                        </p>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default Login;
